/**
 * Converts a present-tense intent description to past tense.
 *
 * Intent descriptions from the backend follow predictable patterns
 * (e.g. "Executing command: X", "Reading website: X", "Create file X").
 * This function converts the leading verb so completed actions read naturally.
 */

// Present participle (-ing) → past tense
const GERUND_TO_PAST: [string, string][] = [
    ["Executing", "Executed"],
    ["Reading", "Read"],
    ["Rebuilding", "Rebuilt"],
    ["Setting", "Set"],
    ["Recording", "Recorded"],
    ["Creating", "Created"],
    ["Spawning", "Spawned"],
    ["Sending", "Sent"],
    ["Signaling", "Signaled"],
    ["Getting", "Got"],
    ["Stopping", "Stopped"],
    ["Deleting", "Deleted"],
    ["Listing", "Listed"],
    ["Parsing", "Parsed"],
    ["Starting", "Started"],
    ["Adding", "Added"],
    ["Marking", "Marked"],
    ["Clearing", "Cleared"],
    ["Advancing", "Advanced"],
    ["Searching", "Searched"],
    ["Updating", "Updated"],
    ["Inserting", "Inserted"],
    ["Replacing", "Replaced"],
];

// Base form → past tense (some DescribeFuncs use imperative: "Read", "Create", etc.)
const BASE_TO_PAST: [string, string][] = [
    ["Read", "Read"],
    ["Replace", "Replaced"],
    ["Create", "Created"],
    ["Insert", "Inserted"],
    ["Update", "Updated"],
    ["Delete", "Deleted"],
    ["Get", "Got"],
    ["List", "Listed"],
    ["Add", "Added"],
    ["Search", "Searched"],
];

export function toPastTense(description: string): string {
    if (!description) {
        return description;
    }

    // Gerunds must be checked before base forms because some base forms are
    // prefixes of gerunds (e.g. "Read" is a prefix of "Reading").
    for (const [present, past] of GERUND_TO_PAST) {
        if (description.startsWith(present + " ") || description === present) {
            return past + description.slice(present.length);
        }
    }

    for (const [base, past] of BASE_TO_PAST) {
        if (description.startsWith(base + " ") || description === base) {
            return past + description.slice(base.length);
        }
    }

    return description;
}
